import { useEffect, useState } from "react";
import { WebSocketMessage, WebSocketService } from "../services/websocket";

export function useWebSocket(url: string | undefined) {
  const [message, setMessage] = useState<WebSocketMessage | null>(null);

  const [isConnected, setIsConnected] = useState<boolean>(false);

  useEffect(() => {
    if (!url) return;

    const ws = WebSocketService.getInstance(url);

    ws.connect();

    const handleOpen = () => setIsConnected(true);
    const handleClose = () => setIsConnected(false);

    const handleMessage = (msg: WebSocketMessage) => {
      setMessage(msg);
    };

    const unsubscribeOpen = ws.onOpen(handleOpen);
    const unsubscribeClose = ws.onClose(handleClose);
    const unsubscribeMessage = ws.onMessage(handleMessage);

    return () => {
      unsubscribeOpen();
      unsubscribeClose();
      unsubscribeMessage();
      ws.disconnect();
      setIsConnected(false);
    };
  }, [url]);

  const wsInstance = url ? WebSocketService.getInstance(url) : null;

  return {
    message,
    sendMessage: wsInstance?.sendMessage.bind(wsInstance),
    isConnected,
    disconnect: wsInstance?.disconnect.bind(wsInstance),
  };
}
